"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventPolyfill = function (type, eventInit) {
    if (eventInit === void 0) { eventInit = {}; }
    var changeEvent = document.createEvent('Event');
    changeEvent.initEvent(type, eventInit.bubbles || false, eventInit.cancelable || false);
    return changeEvent;
};
exports.default = EventPolyfill;
//# sourceMappingURL=event.js.map